import http from '@utils/http'
/**
 * 获取抽奖活动相关信息
 */
export function queryLuckDrawInfo(data): Promise<any> {
    return http.post('/activity/queryLuckDrawInfo', data || {})
}
/**
 * 执行抽奖
 */
export function doLottery(data): Promise<any> {
    return http.post('/activity/draw', data || {})
}
/**
 * 获取用户奖品信息
 */
export function getUserDrawInfo(data): Promise<any> {
    return http.post('/activity/getUserDrawInfo', data || {})
}
/**
 * 中奖套餐兑换
 */
export function goodsReleasePolicy(data): Promise<any> {
    return http.post('/activity/goodsReleasePolicy', data || {})
}
/**
 * 保存实物邮寄信息
 */
export function saveLinkPhone(data): Promise<any> {
    return http.post('/activity/saveLinkPhone', data || {})
}
/**
 * 中奖用户轮播列表
 */
export function winDrawPrizeList(data): Promise<any> {
    return http.post('/activity/winDrawPrizeList', data || {})
}
